module.exports = __webpack_public_path__ + "02_very_short_black.3f46b0bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/02_very_short_black.png
// module id = bcy8
// module chunks = 0